"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingAreaCode = exports.CellId = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Network.Cellular.Nr';
exports.CellId = effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 68_719_476_735)).annotations({
    identifier: `${NAMESPACE}.CellId`,
});
exports.TrackingAreaCode = effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 16_777_215)).annotations({
    identifier: `${NAMESPACE}.TrackingAreaCode`,
});
//# sourceMappingURL=nr.js.map